module.exports = __webpack_public_path__ + "static/media/Scott LeBlanc.b55b8753.jpg";